<template>
  <div class="wrap-login justify-content-center">
    <div class="row">
        <div class="col-xl-4 col-lg-5 col-12 logo-register">
          <router-link to="/" exact>
            <img src="@/assets/images/logo-nxb.png" alt="Hành trang số" style="height:50px;">
          </router-link>
        </div>
      </div>

    <div class="register-page p-2">
        <h2 class="register-title font-size-26 font-sanpro-semibold title-color-gray text-center">Đăng ký</h2>
        <b-tabs class="register-page__tabs border_bottom_gray" align="center">
            <b-tab active @click="changeUserType(1)">
              <template v-slot:title>Học sinh</template>
            </b-tab>
            <!-- <b-tab @click="changeUserType(2)">
              <template v-slot:title>Giáo viên</template>            
            </b-tab> -->
        </b-tabs>
        <b-form @submit="handleRegister" class="info-register pt-3">                

          <div class="form-item">
            <div class="form-content">
              <div class="birthday form-section mt-2">
                <label for="" class="lbl-name font-size-16 font-sanpro-semibold color-form">Ngày sinh</label>
                <div class="birthday-form display-flex justify-content-between" >
                  <div class="birthday-item">
                    <span class="select-custom">
                      <select name="day" class="form-control form-30h form-bg-gray-light border-rd-10 color-form" @change="setDay">
                        <option value="0">Ngày</option>
                        <option v-for="day in days" :value="day">{{ day }}</option>
                      </select>
                      <i class="fa fa-angle-down"></i>
                    </span>
                  </div>
                  <div class="birthday-item">
                    <span class="select-custom">
                        <select name="month" class="form-control form-30h form-bg-gray-light border-rd-10 color-form" @change="setMonth">
                           <option value="0">Tháng</option>
                            <option v-for="month in months" :value="month">{{ month }}</option>
                        </select>
                        <i class="fa fa-angle-down"></i> 
                    </span>
                  </div>
                  <div class="birthday-item">
                    <span class="select-custom">
                        <select name="day" class="form-control form-30h form-bg-gray-light border-rd-10 color-form" @change="setYear">
                          <option value="0">Năm</option>
                          <option v-for="year in years" :value="year">{{ year }}</option>
                        </select>
                        <i class="fa fa-angle-down"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="name-register form-section mt-2" :class="{'disabled': !isFillBirthDayDone && form.userType == 1}"> 
              <div class="form-content">
                <label for="firstname" class="lbl-name font-size-16 font-sanpro-semibold color-form" >Họ</label><br>
                <input 
                  type="text" 
                  v-model="$v.form.firstname.$model"
                  id="firstName" 
                  name="firstName" 
                  class="form-control form-30h form-bg-gray-light border-rd-10 color-form"
                  :placeholder="form.userType==1?'Họ của học sinh':'Họ của bạn'" 
                />
              </div>
              <span class="error display-block color-err font-size-14" v-if="!$v.form.firstname.required && status">Vui lòng điền họ</span>
              <!-- <span class="error display-block color-err font-size-14" v-if="!$v.form.firstname.minLength">Họ ít nhất  {{ $v.form.firstname.$params.minLength.min }} ký tự.</span> -->
            </div>

          <div class="name-register form-section mt-2" :class="{'disabled': !isFillBirthDayDone && form.userType == 1}"> 
               <div class="form-content">
                <label for="lastname" class="lbl-name font-size-16 font-sanpro-semibold color-form">Tên</label><br>
                <input 
                  type="text" 
                  id="lastname" 
                  class="form-control form-30h form-bg-gray-light border-rd-10 color-form" 
                  v-model="$v.form.lastname.$model"
                  :placeholder="form.userType==1?'Tên của học sinh':'Tên của bạn'"
                />
              </div>
              <span class="error display-block color-err font-size-14" v-if="!$v.form.lastname.required && status">Vui lòng điền tên</span>
              <!-- <span class="error display-block color-err font-size-14" v-if="!$v.form.lastname.minLength">Tên ít nhất  {{ $v.form.firstname.$params.minLength.min }} ký tự.</span> -->
            </div>
          <div class="gender form-section" v-if="form.userType==1" :class="{'disabled': !isFillBirthDayDone && form.userType == 1}">
            <label class="lbl-name font-size-16 font-sanpro-semibold color-form">Giới tính</label><br>
            <div class="gender-list display-flex-center justify-content-between">
              <div class="item" v-for="item in genderOptions">
                <div class="radio-custom">
                  <input type="radio" name="radio" :checked="item.value === genderOptions[0].value" :value="item.value" @change="setGenderRegister">
                  <label class="color-form">{{item.text}}</label>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="name-register form-section mt-2" v-if="form.userType==1 && isPrimarySchoolStudent">           
              <div class="form-content">
                <label for="parentFullname" class="lbl-name font-size-16 font-sanpro-semibold color-form" >Họ và tên phụ huynh</label><br>             
                <input 
                  type="text" 
                  v-model="$v.form.parentFullname.$model"
                  id="parentFullname" 
                  name="parentFullname" 
                  class="form-control form-30h form-bg-gray-light border-rd-10 color-form" 
                  placeholder="Họ và tên phụ huynh"
                />
              </div>
              <span class="error display-block color-err font-size-14" v-if="!$v.form.parentFullname.required && status">Vui lòng điền họ và tên phụ huynh</span>
              <span class="error display-block color-err font-size-14" v-if="!$v.form.parentFullname.minLength">Họ và tên phụ huynh ít nhất  {{ $v.form.parentFullname.$params.minLength.min }} ký tự.</span>          
          </div> -->
          <div class="email-register form-section mt-2" :class="{'disabled': !isFillBirthDayDone && form.userType == 1}">
            <div class="form-content">
              <label for="email" class="lbl-name font-size-16 font-sanpro-semibold color-form">Email</label><br>
              <input 
                type="email" 
                id="email" 
                class="form-control form-30h form-bg-gray-light border-rd-10 color-form" 
                v-model="$v.form.email.$model"
                @change="checkEmailExit"
                 placeholder="Email của bạn"
              >
                <!-- :placeholder="form.userType==1 && isPrimarySchoolStudent ? 'Email của phụ huynh' : 'Email của bạn'" -->
            </div>
            <span class="error display-block color-err font-size-14" v-if="!$v.form.email.required && status">Vui lòng điền email</span>
            <span class="error display-block color-err font-size-14" v-if="!$v.form.email.email">Định dạng email chưa đúng</span>
            <span class="error display-block color-err font-size-14" v-if="isEmailExits">Email này đã được sử dụng</span>
          </div>
          <div class="password-register form-section mt-2" :class="{'disabled': !isFillBirthDayDone && form.userType == 1}">
              <div class="form-content">
                  <label for="password" class="lbl-name font-size-16 font-sanpro-semibold color-form" >Mật khẩu</label><br>
                  <div class="input-custom-icon">
                    <input type="password" id="password" class="form-control form-30h form-bg-gray-light border-rd-10 color-form" 
                     placeholder="Mật khẩu"
                     v-model="$v.form.password.$model">
                    <i class="icon-hidden icon-icon-eye" aria-hidden="true" @click="switchVisibility"></i>
                  </div>
              </div>
              <span class="error display-block color-err font-size-14" v-if="!$v.form.password.required && status">Vui lòng điền mật khẩu</span>
              <span class="error display-block color-err font-size-14" v-if="!$v.form.password.minLength">Mật khẩu ít nhất  {{ $v.form.password.$params.minLength.min }} ký tự.</span>
            </div>            
          <div class="password-register form-section mt-2" :class="{'disabled': !isFillBirthDayDone && form.userType == 1}">
              <div class="form-content">
                <label for="confirmPassword"  class="lbl-name font-size-16 font-sanpro-semibold color-form" >Xác nhận</label><br>
                <div class="input-custom-icon">
                  <input type="password" id="confirmPassword" class="form-control form-30h form-bg-gray-light border-rd-10 color-form"
                   placeholder="Mật khẩu" 
                   v-model="$v.form.confirmPassword.$model">
                  <i class="icon-hidden icon-icon-eye" aria-hidden="true" ></i>
                </div>
              </div>            
              <span class="error display-block color-err font-size-14" v-if="!$v.form.confirmPassword.required && status">Vui lòng nhập lại mật khẩu</span>
              <span class="error display-block color-err font-size-14" v-if="!$v.form.confirmPassword.sameAsPassword">Xác nhận mật khẩu không chính xác </span>
            </div>
          <div class="form-action mt-3">
            <button type="button" :disabled="$v.form.$invalid || isEmailExits" class="btn btn-primary btn-register color-light form-control" @click="handleRegister">Đăng ký</button>
          </div>          
          <div class="form-action mt-3  text-center">
            Bạn đã có tài khoản? 
            <router-link :to="{name: 'home'}" class="primary-color font-size-16">Đăng nhập ngay</router-link>
          </div>          
          <div v-if="formErrors" v-for="(item, index) of formErrors">
              <span v-if="item && item.message" class="error display-block color-err font-size-14">{{item.message}}</span>
          </div>
        </b-form>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions, mapState } from 'vuex'
  import { MODULE_TEACHER, MODULE_PUPIL, EMAIL_PUBLIC, PASS_PUBLIC } from '@/store/auth/constants'
  import { required, minLength, sameAs, email } from 'vuelidate/lib/validators'
  import { STORE_KEY } from '@/store/auth/constants'
  import { register, checkExitEmail } from '@/store/auth/api'
  import JWT from "@/utils/jwt"

  const genderOptions = [
    { value: 1, text: "Nam" },
    { value: 2, text: "Nữ" },
    { value: 3, text: "Khác" }
  ];

  const optionsSchoolLevel = [
    { value: 1, text: "Tiểu học" },
    { value: 2, text: "THCS" },
    { value: 3, text: "THPT" }
  ];

  export default {
    name: "RegisterMobi",
    data () {  
      return {
        genderOptions: genderOptions,
        optionsSchoolLevel: optionsSchoolLevel,
        form: {
          firstname:'',
          lastname:'',
          gender: genderOptions[0].value,
          email: '',
          password: '',
          confirmPassword:'',
          schoolTypeId: optionsSchoolLevel[0].value,
          birthday:'',
          userType: 1,
          //1: Hoc Sinh, 2: Giao Vien
          parentFullname: ''
        },
        birthDay: null,
        birthMonth: null,
        birthYear: null,
        password: '',
        passwordFieldType: 'password',
        months: 12,
        days: 31,
        // years: 1950,
        status: false,
        isEmailExits: false,
        formErrors:[],
        isFillBirthDayDone: false,
        isPrimarySchoolStudent: false
      }
    },
    validations(){
      let self = this;
      if(self.form.userType==1){
        return {
          form:{
            firstname: {
            required,
            //minLength: minLength(3)
          },
          lastname:{
            required,
            //minLength: minLength(4)
          },
          gender:{
            // required
          },
          email:{
            required,
            email
          },
          password:{
            required,
            minLength: minLength(6)
          },
          confirmPassword:{
            required,
            sameAsPassword: sameAs('password')
          },
          schoolTypeId:{
            // required,
          },
          birthday:{
            // required
          },
          parentFullname:{
            required: self.isPrimarySchoolStudent ? true : false
          },
         }
        }
      } else {
        return {
          form:{
            firstname: {
            required
          },
          lastname:{
            required
          },
          email:{
            required,
            email
          },
          password:{
            required,
            minLength: minLength(6)
          },
          confirmPassword:{
            required,
            sameAsPassword: sameAs('password')
          },
         }
        }
      }
  	 
    },
    components: {
      
    },
    
    computed: {
      ...mapState('auth', ['isLoggedIn', 'isLoading', 'errors', 'user']),
      ...mapGetters('auth', ['register']),

      years () {
        const year = new Date().getFullYear()
        return Array.from({length: year - 1960}, (value, index) => 1961 + index)
      }

    },
    created(){
        // this.authRegisterTeacher(this.registerTeacher)
    },
    mounted(){
      // this.authRegisterTeacher();
    },
    methods: {
      ...mapActions(`auth`, ['authLogin', 'fetchAuthProfile']),

      onReset() {
        this.form.email = ''
        this.form.firstname = ''
        this.form.lastname = ''
        this.form.gender = ''
        this.form.birthday = ''
        this.form.email = ''
        this.form.password = '' 
        this.form.confirmPassword = ''
        this.form.schoolTypeId = ''
        this.form.checked = []
        this.form.userType = 2
        this.form.parentFullname=''
      },
      handleRegister(){
        let self = this
        self.status = true
        
        // self.form.birthday = `${self.birthYear}-${self.birthMonth}-${self.birthDay}`;
        self.form = { ...self.form, birthday: `${self.birthYear}-${self.birthMonth}-${self.birthDay}` }
        register(self.form).then(res => {
          if(res && !res.errors) {
            let loginToken = self.authLogin({
              username: self.form.email,
              password: self.form.password
            })
          } else{
            this.formErrors = res.errors
          }
        })
        
        // alert("SUCCESS!! :-)\n\n" + JSON.stringify(self.form));
      },

      switchVisibility() {
        // console.log('abd',this.passwordFieldType)
        this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
      },
      
      setGenderRegister(evt) {
        // console.log('change', evt)
        this.form.gender = evt.target.value;
      },
      setschoolTypeId(evt) {
        // console.log('change', evt)
        this.form.schoolTypeId = evt.target.value;
      },

      setDay(evt) {
        // console.log('changeDay', evt)
        this.birthDay = evt.target.value;
        this.checkFillBirthDayDone();
      },
      setMonth(evt) {
        // console.log('changeMonth', evt)
        this.birthMonth = evt.target.value;
        this.checkFillBirthDayDone();
      },
      setYear(evt) {
        // console.log('changeYear', evt)
        this.birthYear = evt.target.value;
        this.checkPrimarySchoolStudent();
        this.checkFillBirthDayDone();
      },

      checkPrimarySchoolStudent() {
        if(this.birthYear && this.birthYear !== 0) {
          let yearCurr = new Date().getFullYear();
          this.isPrimarySchoolStudent = (parseInt(yearCurr) - parseInt(this.birthYear) > 11) ? false : true;
        } else {
          this.isPrimarySchoolStudent = false;
        }
      },

      checkFillBirthDayDone() {
        this.isFillBirthDayDone = this.birthDay && this.birthMonth && this.birthYear && this.birthDay != 0 && this.birthMonth != 0 && this.birthYear != 0 ? true : false;
      },

      checkEmailExit(evt) {
        let self = this;
        let data = evt.target.value;
        self.isEmailExits = false;
        if(data) {
          checkExitEmail({email: data}).then(res => {
            self.isEmailExits = res && res.status === 'failed' ? true : false;
          }).catch(err => console.error(err));
        }
      },
      changeUserType(uType){
        //this.onReset();
        this.form.userType=uType;
      },
      loginFast() {
        var postData={
          username: EMAIL_PUBLIC,
          password: PASS_PUBLIC
        }
        let self = this;
         let loginToken = this.authLogin(postData)
      }
    }
  }
</script>
<style lang="scss" scoped>
</style>
